import { useState } from "react";
import LocationNumber from "./LocationNumber";

function CreateQRCodeForm(props) {
    const [category, setCategory] = useState("none");
    const [number, setNumber] = useState("");

    const updateQRCodeList = () => {
        if (category === "none" || !number) {
            alert("Sørg for at sted og nummer er valgt.");
        } else {
            props.setQRCodes(prev => [...prev, [category, number]]);
            setNumber("");
        };
    };

    return (
        <div className="QRCode-form-container">
            <div className="QRCode-form">
                <LocationNumber
                    number={number}
                    setNumber={setNumber}
                    category={category}
                    setCategory={setCategory}
                    updateQRCodeList={updateQRCodeList}
                />
            </div>
            <button onClick={updateQRCodeList}>Lag QR-kode</button>
        </div>
    );
};

export default CreateQRCodeForm;